import React from 'react';
import { motion } from 'framer-motion';
import { Image as ImageIcon } from 'lucide-react';
const images = ['https://images.unsplash.com/photo-1595476108010-b4d1f10d5e43?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1522337660859-02fbefca4702?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1600948836101-f9ffda59d250?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1580618672591-eb180b1a973f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1560869713-7d0a29430803?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'];
export function Gallery() {
  return <section id="gallery" className="py-24 bg-gray-50" data-id="element-120">
      <div className="container mx-auto px-6 md:px-12" data-id="element-121">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-122">
          <div data-id="element-123">
            <h2 className="font-heading text-4xl md:text-5xl text-dark mb-4" data-id="element-124">
              Мої роботи
            </h2>
            <div className="w-12 h-px bg-accent mb-6 md:mb-0" data-id="element-125"></div>
          </div>
          <a href="#instagram" className="text-sm font-medium text-dark border-b border-dark pb-1 hover:text-accent hover:border-accent transition-colors" data-id="element-126">
            Дивитись більше
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 auto-rows-[300px]" data-id="element-127">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="md:col-span-2 md:row-span-2 relative group overflow-hidden bg-gray-100 border border-gray-200 flex items-center justify-center" data-id="element-128">
            <div className="text-center flex flex-col items-center" data-id="element-129">
              <ImageIcon className="text-gray-300 mb-3" size={32} strokeWidth={1} data-id="element-130" />
              <p className="text-xs text-gray-400 font-light tracking-widest uppercase" data-id="element-131">
                Фото роботи
              </p>
            </div>
            <div className="absolute inset-0 bg-black/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-132"></div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="relative group overflow-hidden bg-gray-100 border border-gray-200 flex items-center justify-center" data-id="element-133">
            <div className="text-center flex flex-col items-center" data-id="element-134">
              <ImageIcon className="text-gray-300 mb-3" size={24} strokeWidth={1} data-id="element-135" />
              <p className="text-xs text-gray-400 font-light tracking-widest uppercase" data-id="element-136">
                Фото роботи
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative group overflow-hidden bg-gray-100 border border-gray-200 flex items-center justify-center" data-id="element-137">
            <div className="text-center flex flex-col items-center" data-id="element-138">
              <ImageIcon className="text-gray-300 mb-3" size={24} strokeWidth={1} data-id="element-139" />
              <p className="text-xs text-gray-400 font-light tracking-widest uppercase" data-id="element-140">
                Фото роботи
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="md:col-span-2 relative group overflow-hidden bg-gray-100 border border-gray-200 flex items-center justify-center" data-id="element-141">
            <div className="text-center flex flex-col items-center" data-id="element-142">
              <ImageIcon className="text-gray-300 mb-3" size={24} strokeWidth={1} data-id="element-143" />
              <p className="text-xs text-gray-400 font-light tracking-widest uppercase" data-id="element-144">
                Фото роботи
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}